import React, { useState } from 'react';
import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

interface OrgLogoProps {
  name: string;
  logoUrl: string | null;
  size?: number;
  onBroken?: () => void;
}

const OrgLogo: React.FC<OrgLogoProps> = ({
  name,
  logoUrl,
  size = 40,
  onBroken,
}) => {
  const theme = useTheme();
  const [broken, setBroken] = useState(false);

  const handleError = () => {
    setBroken(true);
    onBroken?.();
  };

  if (!logoUrl || broken) {
    return (
      <Box
        aria-label={`${name} logo`}
        sx={{
          width: size,
          height: size,
          borderRadius: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: alpha(theme.palette.primary.main, 0.12),
          color: theme.palette.primary.main,
          fontWeight: 700,
          fontSize: size * 0.4,
          flexShrink: 0,
        }}
      >
        {name.charAt(0).toUpperCase()}
      </Box>
    );
  }

  return (
    <Box
      component="img"
      src={logoUrl}
      alt={`${name} logo`}
      width={size}
      height={size}
      onError={handleError}
      sx={{
        width: size,
        height: size,
        objectFit: 'contain',
        borderRadius: 1.5,
        flexShrink: 0,
      }}
    />
  );
};

export default OrgLogo;
